import { MouseEvent, SetStateAction, useCallback } from 'react';

export const useCancelClick = (
  setSelectedUserId: (value: SetStateAction<number | null>) => void,
) => {
  const onCancelClick = useCallback<(e: MouseEvent<HTMLAnchorElement>) => void>(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      setSelectedUserId(null);
    },
    [setSelectedUserId],
  );

  return { onCancelClick };
};
